import {ajax, getUrlParams} from '../../common/utils.js';
import {SET_SHOULD_RELOAD_DATA, SET_DIRTY, SHOW_DIRTY_MODAL, SET_ACTIVE_ORDER, UPDATE_CLIENT_VIEW_PORT} from '../actionTypes';
import {fetchingData, dataFetched, errorFetching} from "../common/fetchingActions";
import {FetchingTypes, OLD_VERSION_MESSAGE} from '../../common/constants';
import {setUrlParams} from "./staticDataActions";
import {replace} from "react-router-redux";

export function setShouldReloadData(shouldReloadData) {
    return {
        type: SET_SHOULD_RELOAD_DATA,
        shouldReloadData
    }
}
export function setDirty(dirty) {
    return {
        type: SET_DIRTY,
        dirty
    }
}
export function setActiveOrder(activeOrder, shouldReloadData) {
    return {
        type: SET_ACTIVE_ORDER,
        activeOrder,
        shouldReloadData
    }
}
export function checkIsDirty(onLeaveCallBack) {
    return function(dispatch, getState){
        const state = getState();
        if (state.orderStatus.isChanged)
            dispatch(showDirtyModal(true, onLeaveCallBack));
        else
            onLeaveCallBack();
    }
}
export function showDirtyModal(show, onLeaveCallBack) {
    return {
        type: SHOW_DIRTY_MODAL,
        show,
        onLeaveCallBack
    }
}

export function updateClientViewPort(visible){
    return {
        type: UPDATE_CLIENT_VIEW_PORT,
        visible
    }
}
export function getCouponData(couponId, setCoupon){
    return function(dispatch, getState){
        const fetchUrl = '/dispatcher/WebStoreService.getCouponDiscount';
        const state = getState();
        let data = {
            farmKey: state.staticData.farmKey,
            seasonKey: state.staticData.seasonKey,
            couponId: couponId
        };
        if((state.summary || {}).key) {
            data["subscriptionKey"] = state.summary.key;
        }
        dispatch(fetchingData(FetchingTypes.VALIDATE_COUPON));
        return ajax(fetchUrl, data)
            .then(json => parseCouponData(json))
            .then(couponData => dispatch(setCoupon(couponData)))
            .then(() => dispatch(dataFetched()))
            .catch(error => {
                dispatch(errorFetching(error));
            })
    }
}

export function parseCouponData(json, existingCoupon){
    if (!json || !json.id)
        return {valid: false};
    return {
        valid: true,
        key: json.key,
        id: json.id,
        discount: json.discount,
        isFixedAmount: json.isFixedAmount,
        minimumOrder: json.minimumOrder,
        firstOrderUse: json.firstOrderUse,
        useMinimumOrder: json.useMinimumOrder,
        validationType: json.validationType,
        couponType: json.couponType,
        calculateOptions: json.calculateOptions,
        existingCoupon
    };
}

export function checkVersion() {
    return function (dispatch, getState) {
        const timeout = 1000 * 60 * 60 * 6;
        window.setTimeout(function () {
            const state = getState();
            const timestamp = new Date().getTime();
            if (timestamp - state.clientViewPort.lastChange < 1000 * 60 * 30){
                dispatch(checkVersion());
                return;
            }
            const fetchUrl = '/dispatcher/WebStoreService.getVersion';
            const data = {
                farmKey: state.staticData.farmKey,
                memberKey: state.memberDetails ? state.memberDetails.key : null
            };
            return ajax(fetchUrl, data)
                .then(version => {
                    if (version != state.staticData.version)
                        dispatch(errorFetching(new Error(OLD_VERSION_MESSAGE)));
                    dispatch(checkVersion());
                })
                .catch()
        }, timeout);
    }
}

export function setAndRemoveUrlParams(onlyHidden) {
    return function (dispatch, getState) {
        const state = getState();
        const params = getUrlParams();
        const urlParams = (state.staticData || {}).params || {};
        let paramsFound = false;
        for (const [key, value] of Object.entries(params)) {
            if (!onlyHidden || ['error', 'message'].includes(key)) {
                urlParams[key] = value;
                delete params[key];
                paramsFound = true;
            }
        }
        if (paramsFound) {
            dispatch(setUrlParams(urlParams));
            const queryString = Object.keys(params).length === 0 ? '' :
                '?' + (Object.entries(params).map(([key, value]) => (`${key}=${value}`)).join('&'));
            dispatch(replace(location.pathname + queryString));
        }
    }
}

export function clearHiddenUrlParams() {
    return function (dispatch, getState) {
        const state = getState();
        const urlParams = (state.staticData || {}).params || {};
        let hiddenFound = false;
        ['error', 'message'].forEach(key => {
            delete urlParams[key];
            hiddenFound = true;
        });
        if (hiddenFound) {
            dispatch(setUrlParams(urlParams));
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/common/commonActions.js